import CircularProgress from '@material-ui/core/CircularProgress';
import { useSharedStyles } from '../shared';
import AttachedResources from './Attached';
import { useAccessCheck } from './hooks/useMyResourcesData';
import NoAttachedResources from './NotAttached';

const MyResources = () => {
  const sharedClasses = useSharedStyles();
  const { loading, canAccess } = useAccessCheck();

  if (loading) {
    return (
      <div className={sharedClasses.loadingCenter}>
        <CircularProgress />
      </div>
    );
  }

  return canAccess ? <AttachedResources /> : <NoAttachedResources />;
};

export default MyResources;
